import React, { useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";

const CareerToggleTabs = () => {
  const [activeToggle, setActiveToggle] = useState(null);

  const handleToggle = (toggleId) => {
    setActiveToggle(activeToggle === toggleId ? null : toggleId);
  };

  return (
    <>
      {/* <div className="career-toggle1 fade-in-down">
        <h5
          className="career-toggle1-title"
          onClick={() => handleToggle("toggle1")}
          style={{
            color: activeToggle === "toggle1" ? "#000" : "#666", // Change color based on toggle state
          }}
        >
          Graphics Designing Internee (1 Position)
          <span>{activeToggle === "toggle1" ? <FaMinus /> : <FaPlus />}</span>
        </h5>
        <div
          className="career-toggle1-content"
          style={{
            maxHeight: activeToggle === "toggle1" ? "1000px" : "0", // Dynamically adjust height
            overflow: "hidden",
            transition: "max-height 0.3s ease",
          }}
        >
          <p>
            We are looking for a Graphic Designer Internee with strong layout
            skills and understanding of UI/UX concepts for mobile, tablets
            & web. He/She will be responsible for creating great Web apps
            and having excellent visual design expertise and be proficient in
            graphic design.
          </p>
          <ul>
            <li>Illustrate concept by designing rough layout of art and copy regarding arrangement, size, type size and style, and related aesthetic concepts.</li>
            <li>Proofreading to produce accurate and high-quality work.</li>
            <li>Working as part of a team.</li>
            <li>Ability to interact, communicate and present ideas.</li>
            <li>Possession of creative flair, versatility, conceptual/visual ability, originality and familiarity with design software and technologies (such as InDesign, Illustrator, Dreamweaver, Photoshop).</li>
            <li>Using innovation to redefine a design brief within the constraints of cost and time.</li>
            <li>Ability to complete projects with minimal supervision.</li>
          </ul>
          <div className="career-apply-button1-container">
            <a className="career-apply-button1" href="mailto:jobs@softisans.com" target="_blank" rel="noopener noreferrer">Apply Now</a>
          </div>
        </div>
      </div>
      <div className="career-toggle2 fade-in-down">
        <h5
          className="career-toggle2-title"
          onClick={() => handleToggle("toggle2")}
          style={{
            color: activeToggle === "toggle2" ? "#000" : "#666", // Change color based on toggle state
          }}
        >
          PHP Laravel Internee (1 Position)
          <span>{activeToggle === "toggle2" ? <FaMinus /> : <FaPlus />}</span>
        </h5>
        <div
          className="career-toggle2-content"
          style={{
            maxHeight: activeToggle === "toggle2" ? "1000px" : "0",
            overflow: "hidden",
            transition: "max-height 0.3s ease",
          }}
        >
          <p>
            We are looking for PHP Laravel Internee. On successful completion of
            the internship program, the ideal candidate will be hired as a
            full-time Developer in the company.
          </p>
          <b>Requirements:</b>
          <ul>
            <li>Graduated in computer science, IT or in Software Engineering.</li>
            <li>Willing to pursue his career in PHP – Laravel.</li>
            <li>Familiar with MVC architecture and frameworks.</li>
            <li>Familiar with JavaScript, JQuery, Ajax, Bootstrap.</li>
            <li>Open to learning and researching about the latest tools and technologies.</li>
            <li>Able to meet the deadlines and can handle pressure.</li>
            <li>Good in communication.</li>
          </ul>
          <div className="career-apply-button2-container">
            <a className="career-apply-button2" href="skype:rizwan-ali?call" target="_blank" rel="noopener noreferrer">Apply Now</a>
          </div>
        </div>
      </div> */}
      <div className="career-toggle1 fade-in-down">
        <h5
          className="career-toggle1-title"
          onClick={() => handleToggle("toggle1")}
          style={{
            color: activeToggle === "toggle1" ? "#000" : "#666",
          }}
        >
          Customer Support & Lead Handler (Real Estate Calls) - 1 Position
          <span>{activeToggle === "toggle1" ? <FaMinus /> : <FaPlus />}</span>
        </h5>

        <div
          className="career-toggle1-content"
          style={{
            maxHeight: activeToggle === "toggle1" ? "1000px" : "0",
            overflow: "hidden",
            transition: "max-height 0.3s ease",
          }}
        >
          <p>
            We are looking for a responsible and well-spoken individual to
            handle incoming calls, manage leads generated from marketing
            campaigns, and respond to real estate inquiries in a professional
            manner.
          </p>

          <b>Requirements:</b>
          <ul>
            <li>
              Good communication and speaking skills (Urdu & basic English
              preferred).
            </li>
            <li>Ability to handle phone calls professionally and politely.</li>
            <li>Experience in customer support or sales is a plus.</li>
            <li>Quick response to leads from ads and campaigns.</li>
            <li>Basic understanding of real estate or willingness to learn.</li>
            <li>Responsible and punctual behavior.</li>
          </ul>

          <div className="career-apply-button1-container">
            <a
              className="career-apply-button1"
              href="mailto:jobs@nexorstech.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Apply Now
            </a>
          </div>
        </div>
      </div>

      <div className="career-toggle2 fade-in-down">
        <h5
          className="career-toggle2-title"
          onClick={() => handleToggle("toggle2")}
          style={{
            color: activeToggle === "toggle2" ? "#000" : "#666",
          }}
        >
          Social Media Manager / Content Handler - 1 Position
          <span>{activeToggle === "toggle2" ? <FaMinus /> : <FaPlus />}</span>
        </h5>

        <div
          className="career-toggle2-content"
          style={{
            maxHeight: activeToggle === "toggle2" ? "1000px" : "0",
            overflow: "hidden",
            transition: "max-height 0.3s ease",
          }}
        >
          <p>
            We are looking for a creative individual to manage social media
            accounts, create posts, and maintain online presence for our real
            estate and tech campaigns.
          </p>

          <b>Requirements:</b>
          <ul>
            <li>
              Experience in managing Facebook, Instagram, and TikTok pages.
            </li>
            <li>Basic knowledge of Canva or similar design tools.</li>
            <li>Ability to create engaging posts and captions.</li>
            <li>
              Understanding of social media trends and engagement strategies.
            </li>
            <li>Consistency in posting and content scheduling.</li>
            <li>Creative mindset with marketing awareness.</li>
          </ul>

          <div className="career-apply-button2-container">
            <a
              className="career-apply-button2"
              href="mailto:abdulqadir8518@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Apply Now
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default CareerToggleTabs;
